import sstcList from '../../assets/sstc.json';
import gtcList from '../../assets/gtc.json';

export class tncMapping {

    public static getSSTCCategory(product?: string, customerSubType?: string, familyType?: string, contractType?: string): string {
        let productName;

        if (product.includes('Maxis Postpaid') && !product.includes('Maxis Postpaid 68')){
            productName = 'Maxis Postpaid';
        } else if (product.includes('Hotlink Prepaid')){
            productName = 'Hotlink Prepaid';
        } else if (product.includes('Hotlink Postpaid')){
            productName = 'Hotlink Postpaid';
        } else if (product.includes('Maxis Fibre') && !product.includes('Maxis Postpaid 68')){
            productName = 'Maxis Fibre';
        } else if (product.includes('Maxis FWBB') || product.includes('Maxis Home')){
            productName = 'Maxis FWBB';
        } else if (product.includes('Maxis Family')){
            productName = 'Maxis Family';
        } else if (product == 'Maxis Family Plan Additional Member 48') {
            productName = 'Maxis Family Plan Additional Member 48';
        } else if (product.includes('Home Zerolution')) {
            productName = 'Home Zerolution'
        } else if (product.includes('Maxis Postpaid Watch')) {
            productName = 'Watch Connect 18'
        } else if (product.includes('Maxis Postpaid Tablet')) {
            productName = 'Tablet Connect 18'
        } else if (product.includes('Maxis Postpaid 68') && !product.includes('Maxis Fibre')) {
            productName = 'Maxis Postpaid 68'
        } else if (product.includes('Maxis Fibre + Maxis Postpaid 68')) {
            productName = 'Maxis Fibre + Maxis Postpaid 68'
        } else if (product.includes('Maxis Postpaid Share 48')) {
            productName = 'Maxis Postpaid Share 48'
        } else if (product.includes('Maxis FWBB + MUP')) {
            productName = 'Maxis FWBB + MUP'
        } else if (product.includes('Maxis Postpaid 68 + SUPP')) {
            productName = 'MOP 68 + SUPP'
        } 
        // console.log('sstc product : ', product);
        // console.log('sstc productName : ', productName);
        // console.log('sstc familyType : ', familyType);
        // console.log('sstc contractType : ', contractType);

        let contType = contractType !== undefined ? contractType : null;
        //console.log('sstc contType : ', contType);
        let tempList = sstcList.filter((item) => item["product"] === productName);
        //console.log('tempList 1 : ', tempList);
        if (familyType) {
            //console.log('tempList 1 : ', tempList);
            let filteredTemplist = tempList.filter((item) => item.hasOwnProperty('familyType') && item["familyType"] === familyType.toUpperCase());
            tempList = filteredTemplist.length > 0 ? filteredTemplist : tempList;
        }
        //console.log('tempList 2 : ', tempList);
        let checkExistTemList;
        if (contType && contType!==null) {
            
            checkExistTemList = tempList.filter((item) => item["contractType"] === contType);
        }

        //console.log('checkExistTemList: ', checkExistTemList);

        return checkExistTemList === undefined || checkExistTemList.length === 0 ? tempList[0]?.category : checkExistTemList[0].category;
    }

    public static getGeneralTermsCategory(product?: string, customerSubType?: string, familyType?: string): string{
        if (customerSubType === null) { 
            if (product.includes('Maxis Postpaid') || product.includes('Maxis Fibre') 
            || product.includes('Maxis FWBB') || product.includes('Maxis Home') 
            || product.includes('Maxis Unlimited Postpaid') || product.includes('Maxis Family')){
                customerSubType = 'Maxis Individual';
            } else if (product.includes('Hotlink Prepaid')){
                customerSubType = 'Individual';
            } else if (product.includes('Hotlink Postpaid')){
                customerSubType = 'Hotlink Individual';
            }
        }

        // console.log('customerSubType : ', customerSubType);
        
        let list = gtcList.filter((item) => item["customerSubtype"] === customerSubType);
        return list.length == 0 ? null : list[0].category;
        
    }
    
    public static isEcomZerolutionAudio(product?: string, customerSubType?: string, familyType?: string, contractType?: string): boolean{
        if(contractType && (contractType.toLowerCase() === "zerolution" || contractType.toLowerCase() === "k2")){
            return true;
        }
        return false;
    }

}